<template>
	<a class="to-top" @click="scrollToTop()">
		<svg width="12" height="32" viewBox="0 0 12 34" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 0L6 30" stroke="currentColor" />
			<path d="M6 34L11.1962 29.5H0.803848L6 34Z" fill="currentColor" />
		</svg>
	</a>
</template>

<script setup>
const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.to-top');
	if (window.pageYOffset >= 350) {
		fixedElements.forEach((el) => el.classList.add('show'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('show'));
	}
};

const scrollToTop = () => {
	window.scroll({
		top: 0,
		left: 0,
		behavior: 'smooth',
	});
};

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="scss" scoped>
.svg-icon {
	position: absolute;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
	opacity: 0.8;
	pointer-events: none;
}

.to-top {
	position: fixed;
	bottom: -10px;
	left: 50%;
	transform: translateX(-50%) rotate(180deg);
	opacity: 0;
	background-size: 70% 70%;
	background-color: rgb(255 255 255 / 30%);
	width: 36px;
	height: 36px;
	text-align: center;
	line-height: 36px;
	cursor: pointer;
	border-radius: 0 0 50% 50%;
	z-index: 100;
	color: #d3d3d3;

	&:hover {
		color: var(--cta-color);
	}

	&.show {
		opacity: 1;
	}

	span {
		border-top: 1px solid #333;
		border-right: 1px solid #333;
		width: 10px;
		height: 10px;
		transform: rotate(-45deg);
		display: block;
	}
}
</style>
